import React from "react";
import { Box, Typography } from "@mui/material";
import SteminpeLeaderboardTopPlaySkill from "../../components/leaderboards/SteminpeLeaderboardTopPlaySkill";

const SteamTopParticipantSportLeaderboard = () => (
    <Box>
        <SteminpeLeaderboardTopPlaySkill />
    </Box>
);

export default SteamTopParticipantSportLeaderboard;